import React from 'react';
import { GiftIcon } from 'lucide-react';
export function GiftSection() {
  return <section className="text-center" data-id="element-112">
      <div className="bg-gradient-to-br from-red-900/40 to-red-800/30 border-2 border-red-500 rounded-2xl p-6 md:p-8 lg:p-10 shadow-2xl max-w-3xl mx-auto" data-id="element-113">
        <div className="flex items-center justify-center mb-4" data-id="element-114">
          <GiftIcon className="h-12 w-12 md:h-16 md:w-16 text-red-400" data-id="element-115" />
        </div>
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4 leading-tight" data-id="element-116">
          Regalo Exclusivo
        </h2>
        <p className="text-lg md:text-xl text-red-300 font-semibold mb-6" data-id="element-117">
          (Valorado en $297)
        </p>
        <p className="text-base md:text-lg text-gray-200 leading-relaxed" data-id="element-118">
          Tu <span className="font-bold text-white" data-id="element-119">REGALO GRATIS</span>: Un
          regalo sorpresa diseñado para ayudarte a implementar lo que aprenderás
          en la masterclass en vivo de Info Commerce AI. Solo lo revelaré a
          quienes asistan.
        </p>
      </div>
    </section>;
}